












import { Component, Vue } from 'vue-property-decorator'

import { Meta } from '@/helpers/decorators'
import ReportsList from '@/views/reports/list/ReportsList.vue'
import Tabs from '@/components/common/Tabs.vue'

@Component({
  components: {
    ReportsList,
    Tabs
  }
})
export default class ListPendingFirstReports extends Vue {
  @Meta
  metas() {
    return {
      title: this.$t('menu.reports'),
      titleTemplate: `${this.$t('reports.state.pending_first')} - %s - ${process.env.VUE_APP_NAME}`
    }
  }
}
